// extracted by mini-css-extract-plugin
export default {"change-permission-modal":"ChangePermissionsModal_change-permission-modal__I70Ml","avatar":"ChangePermissionsModal_avatar__r1kFx"};